import React from 'react';
import { motion } from 'framer-motion';
import EditableField from './EditableField';
import './About.css';

const stats = [
  { value: '30+', label: 'Years in Business' },
  { value: '1994', label: 'Page Industries Founded' },
  { value: '2007', label: 'Chummy Chum Founded' },
  { value: 'Palawan', label: 'Sheraton Hotel Project' },
];

function About() {
  return (
    <section className="about section-padding" id="about">
      <div className="container">
        <motion.div
          className="about__header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">MY STORY</span>
          <h2 className="section-title">
            A life dedicated to<br />
            <span className="text-gradient">business & compassion</span>
          </h2>
        </motion.div>

        <div className="about__grid">
          <motion.div
            className="about__image-wrapper"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8 }}
          >
            <div className="about__image">
              <span>Ramesh Genomal</span>
            </div>
          </motion.div>

          <motion.div
            className="about__content"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <EditableField
              storageKey="about-text-1"
              defaultValue="Ramesh Genomal is a visionary entrepreneur and philanthropist. As co-founder and Non-Executive Director of Page Industries Limited, he helped bring Jockey International to India in 1994, building it into one of the country's most recognized apparel brands."
              tag="p"
              className="about__text"
              multiline
            />
            <EditableField
              storageKey="about-text-2"
              defaultValue="Beyond business, Ramesh founded the Chummy Chum Foundation in 2007, a self-funded family initiative dedicated to bringing joy and companionship to underprivileged children in the Philippines and India through storytelling, music, and play."
              tag="p"
              className="about__text"
              multiline
            />

            <div className="about__info">
              <div className="about__info-item">
                <span className="about__info-label">LOCATION</span>
                <EditableField storageKey="about-location" defaultValue="Philippines & India" tag="span" className="about__info-value" />
              </div>
              <div className="about__info-item">
                <span className="about__info-label">EDUCATION</span>
                <EditableField storageKey="about-education" defaultValue="MBA, Hofstra University, New York" tag="span" className="about__info-value" />
              </div>
              <div className="about__info-item">
                <span className="about__info-label">INTERESTS</span>
                <EditableField storageKey="about-interests" defaultValue="Philanthropy, Children's Welfare, Music" tag="span" className="about__info-value" />
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="about__stats"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          {stats.map((stat, index) => (
            <div className="about__stat" key={index}>
              <span className="about__stat-value">{stat.value}</span>
              <span className="about__stat-label">{stat.label}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default About;
